/**
 * Add a script tag to the iframe head.
 *
 * @param {Document} document to target (required)
 * @param {object} attributes html attributes to apply to the script tag, including src (optional)
 * @param {string} scriptContent actual script content to be wrapped by the script tag (optional)
 */
const addScript = async (
  targetDocument,
  attributes,
  scriptContent = null,
  prepend = false,
) => {
  const script = targetDocument.createElement('script');
  script.type = 'text/javascript';

  const scriptLoadPromise = new Promise((resolve) => {
    script.onload = resolve;
    script.onerror = resolve; // we can't let one little failed script fetch take down the whole eReader
  });

  for (let attribute in attributes) {
    script[attribute] = attributes[attribute];
  }

  if (scriptContent) {
    script[window.opera ? 'innerHTML' : 'text'] = scriptContent;
  }

  if (prepend) {
    targetDocument.head.prepend(script);
  } else {
    targetDocument.head.append(script);
  }

  if (script.src) {
    // Wait for script to load.
    await scriptLoadPromise;
  }
};

export default addScript;
